module.exports = __webpack_public_path__ + "img/demo_0.d80857d2.jpg";